export default __webpack_public_path__ + "static/media/bandcamp-dark.56787908.svg";